<template>
    <div id="WordLoadMobile">
        <nav-bar style="background-color: #0092FF">
            <link-mobile slot="left" link="/WordMobile"><</link-mobile>
            <div slot="center">账号登录</div>
            <link-mobile slot="right" link="/WordMoreMobile"><i class="el-icon-more"></i></link-mobile>
        </nav-bar>
        <Scroll class="wrapper" ref="scroll"
                :probe-type="3"
                :pull-up-load="true">


        <el-row :gutter="24"   v-loading="loading">
            <el-col :span="24"><div class="grid-content bg-purple">
                <el-card :body-style="{ left: '0px' }" shadow="hover">
                    <el-header :style="{'font-size': '20px',left: '0%','position': 'relative'}">
                        密码登录

                    </el-header>
                    <el-form label-position="left" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm":style="{'left':'0px'}">
                        <el-form-item label="" prop="userAccount">
                            <el-input v-model.number="ruleForm.userAccount" placeholder="请输入账号:" prefix-icon="el-icon-user"></el-input>
                        </el-form-item>

                        <el-form-item label="" prop="pass">
                            <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码:" prefix-icon="el-icon-lock"  @keyup.enter.native="submitForm('ruleForm')"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                            <el-button @click="resetForm('ruleForm')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div></el-col>

        </el-row>
            <div>
                {{this.$store.state.a.info.username}}
            </div>
        </Scroll>

    </div>
</template>

<script>
    import NavBar from "../../../components/navbar/NavBar";
    import Scroll from "../../../components/scroll/Scroll";
    import LinkMobile from "../../../components/link/LinkMobile";
    export default {
        name: "WordLoadMobile",
        components:{
            NavBar,
            Scroll,
            LinkMobile,
        },
        data() {
            var checkAccount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('账号不能为空'));
                }
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('请输入数字值'));
                    } else {
                        if (value < 18) {
                            callback(new Error('账号长度必须大于2'));
                        } else {
                            callback();
                        }
                    }
                }, 1000);
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    callback();
                }
            };


            return {
                ruleForm: {
                    userAccount: '',
                    pass: '',

                },
                rules: {
                    pass: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    userAccount: [
                        { validator: checkAccount, trigger: 'blur' }
                    ]
                },
                loading: false
            };
        },
        activated(){
            // alert(this.$store.state.a.info.username!=null);
            // if(this.$store.state.a.info.username!=0){
            //     this.$router.replace('/WordAccountMobile')
            // }

        },
        methods: {
            submitForm(formName) {
                this.loading=true;

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$store.dispatch('requireWordLogin', this.ruleForm).then(res => {
                            this.$message({
                                message: '恭喜' + res + ',你已成功登陆',
                                type: 'success'
                            });
                            this.loading=false;
                            this.$store.dispatch('requireAllPlanWord');
                            this.$router.replace('/WordAccountMobile')
                        }).catch(res=>{
                            this.loading=false;
                            this.$message({
                                message: '请输入正确的账号密码',
                                type: 'error'
                            });
                        });
                    } else {
                        console.log('error submit!!');
                        this.loading=false;
                        return false;
                    }
                });
            },
            login(ruleForm) {
                // this.loginUser.username=ruleForm.userAccount;
                // this.loginUser.password=ruleForm.pass;
                console.log(ruleForm.userAccount);
                this.$store.dispatch('requireWordLogin', this.ruleForm).then(res => {
                    this.$message({
                        message: '恭喜' + res + ',你已成功登陆',
                        type: 'success'
                    });
                    this.dialogFormVisible = false;
                });

            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
    #WordLoadMobile{
        height: 100vh;
    }
    .wrapper{
        position: relative;
        height: calc(100% - 93px);
        /*height: 580px;*/
        /*background-color: red;*/
        overflow: hidden;
        /*overflow: hidden;*/
        position: relative;
        padding-left: 0px;
    }
</style>